import { Checkbox } from 'primereact/checkbox';
import React from 'react';
import useCotizacion from 'src/hooks/useCotizacion';
import usePaginaPago from 'src/reducers/PaginaPago/usePaginaPago';

const TerminosCondicionesCheck = () => {
  const { cotizacion } = useCotizacion();
  const { tieneTerminosCondiciones, urlTerminosCondiciones } = cotizacion;
  const { terminosAceptados, aceptarTerminos } = usePaginaPago();

  if (!tieneTerminosCondiciones) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="col-11 col-sm-10 col-md-7 col-xl-5">
        <div className="d-flex flex-row justify-content-center">
          <Checkbox
            inputId="terminosCondiciones"
            className="check__aceptar__terminos__condiciones"
            onChange={({ checked }) => aceptarTerminos(checked)}
            checked={terminosAceptados}
          />
          <label
            htmlFor="terminosCondiciones"
            className="label__aceptar__terminos__condiciones form-check-label  ml-2"
          >
            Acepto términos y condiciones
            {urlTerminosCondiciones && (
              <a
                className="terminos__condiciones__link pointer"
                href={urlTerminosCondiciones}
                target="_blank"
                rel="noopener noreferrer"
              >
                {' Ver términos'}
              </a>
            )}
          </label>
        </div>
      </div>

      <div className="col-12" />
    </React.Fragment>
  );
};

export default TerminosCondicionesCheck;
